import './App.css';
import RuedaVidaTest from './rueda';

function App() {
  return (
    <div className="App">
      <RuedaVidaTest />
    </div>
  );
}

export default App;
